// extracted by mini-css-extract-plugin
module.exports = {"pillSection":"_3untXfAD"};